import { render, staticRenderFns } from "./Substructures.vue?vue&type=template&id=483b2312&"
import script from "./Substructures.vue?vue&type=script&lang=js&"
export * from "./Substructures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports